import { FadeIn } from "@/components/FadeIn";
import {
  BookOpen,
  GraduationCap,
  Sprout,
  Tractor,
  FileText,
  Users,
  Network,
  Presentation,
} from "lucide-react";

const SERVICES = [
  {
    id: "beginner-course",
    icon: BookOpen,
    title: "Beginner Course",
    note: "Pond & Aquaculture Basics",
    price: "$199",
  },
  {
    id: "advanced-course",
    icon: GraduationCap,
    title: "Advanced Course",
    note: "Small-Scale Aquaculture Systems",
    price: "$349",
  },
  {
    id: "field-workshops",
    icon: Sprout,
    title: "Field Workshops",
    note: "One-day workshops across rural Alberta",
    price: "$149/day",
  },
  {
    id: "farm-tours",
    icon: Tractor,
    title: "Farm Tours",
    note: (
      <>
        Small group visits to ponds, farms,
        <br className="hidden lg:block" /> and suppliers
      </>
    ),
    price: "$249/person",
  },
  {
    id: "consulting",
    icon: FileText,
    title: "One-on-one Consulting",
    note: "Individual consultation or a complete written pond development plan",
    price: "From $250 / $1,200 plan",
  },
  {
    id: "membership",
    icon: Users,
    title: "Membership",
    note: "Resource library, checklists, contractor directory, seasonal updates",
    price: "$299/year",
  },
  {
    id: "partner-directory",
    icon: Network,
    title: "Partner Directory",
    note: "A vetted listing of contractors and suppliers serving Alberta pond projects",
    price: "$500/year",
  },
  {
    id: "organization-training",
    icon: Presentation,
    title: "Organization Training",
    note: "Colleges, municipalities, agricultural groups",
    price: "From $2,500/day",
  },
];

export const WaysWeHelp = () => {
  return (
    <section id="ways-we-help" data-testid="ways-we-help-section" className="bg-background">
      <div className="mx-auto w-full max-w-[1280px] px-5 sm:px-8 pt-[15px] lg:pt-[60px] pb-[50px] lg:pb-10">
        <FadeIn>
          <h2 className="font-serif-heading font-medium text-4xl sm:text-5xl lg:text-[clamp(2.25rem,2.9vw+0.5rem,3.4rem)] leading-[1.05] tracking-[-0.015em] text-foreground">
            Ways we help
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-foreground/65 max-w-[56ch] lg:max-w-none">
            Every journey starts with a free introductory consultation.
            <br className="hidden lg:block" /> We'll help you choose the right path for your property.
          </p>
        </FadeIn>

        <div className="mt-[41px] lg:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <FadeIn key={service.id} delay={0.05 + (i % 4) * 0.05} className="h-full">
                <article
                  data-testid={`ways-we-help-card-${service.id}`}
                  className="note-slip h-full flex flex-col p-5 sm:p-6 lg:px-[19px]"
                >
                  <Icon
                    className="h-6 w-6 text-[color:var(--apn-forest)]"
                    strokeWidth={1.25}
                    aria-hidden="true"
                  />
                  <h3 className="mt-5 font-serif-heading text-lg sm:text-xl font-medium leading-snug text-foreground">
                    {service.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-foreground/60">
                    {service.note}
                  </p>
                  <p
                    data-testid={`ways-we-help-price-${service.id}`}
                    className="mt-auto pt-6 font-mono-meta text-[10px] text-[color:var(--apn-forest)]"
                  >
                    {service.price}
                  </p>
                </article>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
};
